import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { BankAccountDataService } from '../../services/bank-account-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-account-detail',
  templateUrl: './account-detail.component.html',
  styleUrls: ['./account-detail.component.scss']
})
export class AccountDetailComponent implements OnInit {
  showPopupFlag = false;
  popupData: any;
  consentData: any = {};
  eventID: any;

  constructor(
    private bankService: BankAccountDataService,
    private route: Router,
  ) { }
  @Input()
  accountData;
  @Input()
  revokeOption;
  @Input()
  fipDetail;
  bankLogos: any;
  @Input()
  isActiveConsentRecord;
  @Input()
  linkedAccounts;

  @Output() consentRevokeId = new EventEmitter();
  @Output() moveToTimeline = new EventEmitter();
  @Output() consentUpdateEvent = new EventEmitter();

  isConsentRevoked;
  isConsentPaused;

  ngOnInit() {
    this.getBankLogos();
    
  }

  ngOnChanges() {
    this.isConsentRevoked = this.accountData.status == 'REVOKED' ? true : false;
    this.isConsentPaused = this.accountData.status == 'PAUSED' ? true : false;
  }

  getBankLogos() {
    if(this.bankLogos == undefined || this.bankLogos == null) {
      this.bankService.getBanksLogos().subscribe((res) => {
        if (res != undefined) {
          this.bankLogos = res;
        }
      });
    }
  }

  consentRevoke(consentId) {
    let params = {
      consentId : consentId,
      accounts:[this.accountData.accountRefNumber]
    }
    this.consentRevokeId.emit(params);
  }

  consentTimeline(consentArtefactId) {
    this.route.navigate(['/consent-timeline',consentArtefactId]);
  }

  consentUpdate(consentId) {
    let params = {
      status : this.accountData.status == 'PAUSED' ? "ACTIVE" : "PAUSED",
      consentId : consentId,
      accounts:[this.accountData.accountRefNumber]
    }
    this.consentUpdateEvent.emit(params);
  }
}
